/** Mirrors Platform market-analysis-config/v1; limits are not quotes or permissions. */
export type MarketAnalysisConfig =
    | { schema_version: 'market-analysis-config/v1'; enabled: false }
    | { schema_version: 'market-analysis-config/v1'; enabled: true; max_records: number;
        max_model_calls: number; estimated_work_units_limit: string };

export function normalizeAnalysisConfig(value: unknown): MarketAnalysisConfig {
    const invalid = () => new Error('Invalid analysis budget');
    if (!value || typeof value !== 'object' || Array.isArray(value)) throw invalid();
    const input = value as Record<string, unknown>;
    if (input.schema_version !== 'market-analysis-config/v1' || typeof input.enabled !== 'boolean') throw invalid();
    if (!input.enabled) {
        if (Object.keys(input).length !== 2) throw invalid();
        return { schema_version: 'market-analysis-config/v1', enabled: false };
    }
    const integer = (v: unknown, max: number) => typeof v === 'number' && Number.isInteger(v) && v >= 1 && v <= max;
    if (Object.keys(input).length !== 5 || !integer(input.max_records, 5000) || !integer(input.max_model_calls, 200)
        || typeof input.estimated_work_units_limit !== 'string'
        || !/^(?:0|[1-9][0-9]{0,4})(?:\.[0-9]{1,2})?$/.test(input.estimated_work_units_limit)
        || Number(input.estimated_work_units_limit) < 0.01 || Number(input.estimated_work_units_limit) > 10000) throw invalid();
    return { schema_version: 'market-analysis-config/v1', enabled: true,
        max_records: input.max_records as number, max_model_calls: input.max_model_calls as number,
        estimated_work_units_limit: String(Number(input.estimated_work_units_limit)) };
}

export function validAnalysisConfig(value: unknown): boolean {
    if (value === undefined) return true; // Omission preserves legacy behavior; null does not.
    try { normalizeAnalysisConfig(value); return true; } catch { return false; }
}

export function analysisConfigMatches(requested: unknown, echoed: unknown): boolean {
    if (requested === undefined) return true; // Old writers do not own the persisted budget.
    try {
        return JSON.stringify(normalizeAnalysisConfig(requested)) === JSON.stringify(normalizeAnalysisConfig(echoed));
    } catch { return false; }
}
